import React from 'react';
import { Link } from 'react-router-dom';

export default function About() {
  return (
    <div className="page">
      <div className="container" style={{ maxWidth: '860px', padding: '3rem 2rem' }}>
        <div className="page-header">
          <h1>About AstroA2Z</h1>
          <p>Your complete guide to the cosmos — from A to Z</p>
        </div>

        <div className="static-content">
          <section className="about-hero-section">
            <p className="about-intro">
              AstroA2Z is a comprehensive astrology platform dedicated to making ancient Vedic and
              Western astrological wisdom accessible to everyone. We combine centuries-old traditions
              with modern technology to deliver accurate, meaningful insights into your life journey.
            </p>
          </section>

          <section>
            <h2>Our Mission</h2>
            <p>
              We believe that astrology is a profound tool for self-discovery and personal growth.
              Our mission is to provide the most accurate astrological readings powered by the
              Swiss Ephemeris — the gold standard in astronomical calculations — presented in a
              way that is easy to understand and deeply meaningful.
            </p>
          </section>

          <section>
            <h2>What We Offer</h2>
            <div className="about-features">
              <div className="about-feature-item">
                <span className="about-icon">🪬</span>
                <div>
                  <h3>Kundali &amp; Birth Charts</h3>
                  <p>Precise Vedic birth charts with detailed planetary positions, house placements, and dasha periods.</p>
                </div>
              </div>
              <div className="about-feature-item">
                <span className="about-icon">🪷</span>
                <div>
                  <h3>Daily Horoscopes</h3>
                  <p>Personalised daily, weekly, and monthly horoscopes for all 12 zodiac signs.</p>
                </div>
              </div>
              <div className="about-feature-item">
                <span className="about-icon">💕</span>
                <div>
                  <h3>Compatibility Matching</h3>
                  <p>Detailed Vedic compatibility analysis using Ashtakoot matching for relationships.</p>
                </div>
              </div>
              <div className="about-feature-item">
                <span className="about-icon">🌙</span>
                <div>
                  <h3>Moon Phases &amp; Nakshatras</h3>
                  <p>Real-time moon phase tracking and 27 Nakshatra readings with remedies.</p>
                </div>
              </div>
              <div className="about-feature-item">
                <span className="about-icon">📅</span>
                <div>
                  <h3>Muhurat Calculator</h3>
                  <p>Find auspicious timings for important life events using traditional Panchang.</p>
                </div>
              </div>
              <div className="about-feature-item">
                <span className="about-icon">✨</span>
                <div>
                  <h3>Ask an Astrologer</h3>
                  <p>Get personalized guidance from our AI-powered astrology assistant.</p>
                </div>
              </div>
            </div>
          </section>

          <section>
            <h2>Our Technology</h2>
            <p>
              AstroA2Z is built on the Swiss Ephemeris (SwissEph), the most accurate astronomical
              calculation library available, trusted by professional astrologers worldwide. Our
              platform supports both Vedic (sidereal) and Western (tropical) astrology systems,
              giving you the flexibility to explore whichever tradition resonates with you.
            </p>
          </section>

          <section>
            <h2>Our Values</h2>
            <ul>
              <li><strong>Accuracy:</strong> We use industry-leading astronomical data for all calculations.</li>
              <li><strong>Respect:</strong> We honour both ancient traditions and modern interpretations.</li>
              <li><strong>Inclusivity:</strong> Astrology is for everyone, regardless of background or belief.</li>
              <li><strong>Privacy:</strong> Your personal data is treated with the utmost care and respect.</li>
            </ul>
          </section>

          <section className="about-cta">
            <h2>Begin Your Journey</h2>
            <p>
              Whether you're new to astrology or a seasoned practitioner, AstroA2Z has something
              for you. Start with your free birth chart or explore your daily horoscope today.
            </p>
            <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap', marginTop: '1.5rem' }}>
              <Link to="/kundali" className="btn btn-primary">Get Your Kundali</Link>
              <Link to="/horoscope" className="btn btn-secondary">Daily Horoscope</Link>
              <Link to="/contact" className="btn btn-gold">Contact Us</Link>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}
